import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { useLocalization } from '@/hooks/useLocalization';

type SavedOption = {
  MultipleInviteId: number | string;
  InviteName?: string | null;
};

type Props = {
  options: SavedOption[];
  selectedId?: string | number;
  loading?: boolean;
  onChange: (value: string | number) => void;
};

const SavedInvitationSelector = ({
  options,
  selectedId,
  loading,
  onChange,
}: Props) => {
  const { t } = useLocalization();
  return (
    <Box>
      <Typography
        variant='subtitle1'
        sx={{ mb: 0.5 }}
      >
        <b>{t('bulkInvite.chooseSaved', 'Choose a saved invitation')}</b>
      </Typography>
      <RadioGroup
        value={selectedId ?? ''}
        onChange={(e) => onChange((e.target as HTMLInputElement).value)}
      >
        {options.map((invite) => (
          <FormControlLabel
            key={String(invite.MultipleInviteId)}
            value={String(invite.MultipleInviteId)}
            control={<Radio disabled={loading} />}
            label={String(invite.InviteName || invite.MultipleInviteId)}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default SavedInvitationSelector;
